import React, { useState, useContext } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardActions,
  TextField,
  Typography,
  Link as MuiLink,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../hooks';
import { loginUser } from '../services/userService';

export function LogIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { updateUser } = useContext(UserContext);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null); // Reset error before submitting

    try {
      const data = await loginUser(email, password);

      if (data.success) {
        // Update context and local storage
        updateUser({
          id: data.user.id,
          email: data.user.email,
          name: data.user.name,
          surname: data.user.surname,
          dni: data.user.dni,
          phone: data.user.phone,
          dob: data.user.dob?.split('T')[0],
          league: data.user.league,
          role: data.user.role,
          image: data.user.image,
          universityCard: data.user.universityCard,
          subscriptions: data.user.subscriptions,
        });
        navigate('/home'); // Redirect to home
      } else {
        setError(data.message || 'Email o contraseña incorrectos.'); // Display error message
      }
    } catch (err) {
      console.error('Error during login:', err);
      setError('Ocurrió un error al intentar iniciar sesión.');
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f4f6f8',
        padding: 2,
      }}
    >
      <Card sx={{ width: 400, boxShadow: 3, textAlign: 'center' }}>
        {/* Logo */}
        <Box
          component="img"
          src="logo.png" // Replace with your logo path
          alt="Logo"
          sx={{
            width: 100,
            height: 'auto',
            margin: '0 auto',
            marginTop: 3,
            marginBottom: 2,
          }}
        />

        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            sx={{ mb: 4 }}
            gutterBottom
          >
            Iniciar Sesión
          </Typography>
          {error && (
            <Typography color="error" textAlign="center" gutterBottom>
              {error}
            </Typography>
          )}
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
          >
            <TextField
              label="Correo electrónico"
              type="email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={e => setEmail(e.target.value)}
              error={Boolean(error)}
            />
            <TextField
              label="Contraseña"
              type="password"
              variant="outlined"
              fullWidth
              value={password}
              onChange={e => setPassword(e.target.value)}
              error={Boolean(error)}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1 }}
            >
              Iniciar Sesión
            </Button>
          </Box>
        </CardContent>
        <CardActions
          sx={{ flexDirection: 'column', textAlign: 'center', pb: 1 }}
        >
          <MuiLink
            component={Link}
            to="/register"
            underline="none"
            sx={{ mb: '-4px' }}
          >
            <Button variant="text" color="primary">
              Crear una cuenta
            </Button>
          </MuiLink>
          <MuiLink
            component={Link}
            to="/reset"
            underline="none"
            sx={{ mb: '-4px' }}
          >
            <Button variant="text" color="primary">
              ¿Olvidaste tu contraseña?
            </Button>
          </MuiLink>
          <MuiLink component={Link} to="/resend-verification" underline="none">
            <Button variant="text" color="secondary">
              Reenviar código de activación
            </Button>
          </MuiLink>
        </CardActions>
      </Card>
    </Box>
  );
}

export default LogIn;
